module.exports = __webpack_public_path__ + "img/PlusPink.1791d2de.svg";